export const LIFE_SCIENCES_DIVISION_NAME = 'Life Sciences';

export const LIFE_SCIENCES_CLIENT_SEARCH_MIN_LENGTH = 3;

export const LIFE_SCIENCES_SOURCE_TYPE = 'SSO';

export const LIFE_SCIENCES_SERVICE_BASE_PATH = '/life-science-service';
